// src/components/AboutUs.js
import React from "react";
import aboutImg from "./img/tech.png"; // 👈 Import your local image

const AboutUs = () => {
  return (
    <section style={styles.section}>
      {/* Left: Animated Image */}
      <div style={styles.imageContainer} className="imageContainer">
        <img
          src={aboutImg} // 👈 Use imported local image
          alt="About Us"
          style={styles.image}
          className="float-animation"
        />
      </div>

      {/* Right: Content */}
      <div style={styles.content} className="content">
        <h2 style={styles.heading}>About Us</h2>
        <p style={styles.paragraph}>
          We are a passionate team dedicated to creating impactful digital
          solutions. Our mission is to blend creativity, innovation, and
          technology to deliver outstanding experiences for our clients.
        </p>
        <p style={styles.paragraph}>
          From web development to design and strategy, we strive to push
          boundaries and build products that inspire growth and success.
        </p>
      </div>

      {/* Inline CSS keyframes */}
      <style>
        {`
          @keyframes float {
            0% { transform: translateY(0); }
            50% { transform: translateY(-15px); }
            100% { transform: translateY(0); }
          }

          .float-animation {
            animation: float 3s ease-in-out infinite;
          }

          @keyframes fadeSlideInLeft {
            from { transform: translateX(-100px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }

          @keyframes fadeSlideInRight {
            from { transform: translateX(100px); opacity: 0; }
            to { transform: translateX(0); opacity: 1; }
          }

          .imageContainer {
            animation: fadeSlideInLeft 1s ease forwards;
          }

          .content {
            animation: fadeSlideInRight 1s ease forwards;
          }
        `}
      </style>
    </section>
  );
};

const styles = {
  section: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "4rem 2rem",
    background: "linear-gradient(to right, #fafafa, #f0e6da)",
  },
  imageContainer: {
    flex: "1",
    display: "flex",
    justifyContent: "center",
  },
  image: {
    width: "80%",
    maxWidth: "400px",
    borderRadius: "20px",
    boxShadow: "0 8px 24px rgba(0,0,0,0.2)",
  },
  content: {
    flex: "1",
    paddingLeft: "2rem",
  },
  heading: {
    fontSize: "2rem",
    fontWeight: "bold",
    color: "#8B4513",
    marginBottom: "1rem",
  },
  paragraph: {
    fontSize: "1.1rem",
    lineHeight: "1.7",
    color: "#333",
    marginBottom: "1rem",
  },
};

export default AboutUs;
